import { Helmet } from 'react-helmet-async';
import TermsAndConditionsView from 'src/sections/terms-and-conditions/view/view';
// components


// ----------------------------------------------------------------------

export default function Support() {
  return (
    <>
      <Helmet>
        <title> Support</title>
      </Helmet>

      <TermsAndConditionsView />
    </>
  );
}
